import React from 'react';
import styled from 'styled-components'
import { Section } from './Page.styles'
import CertifiedBodyCode from './Images/CertifiedBodyCode'
import CertifiedEmotionCode from './Images/CertifiedEmotionCode'
import InsideOut from './Images/InsideOut'
import Healer from './Images/HealingSuccessGuide'
import Podcast from './Images/Podcast'
import Fade from 'react-reveal/Fade'
import spotify from '../images/podcast/spotify.png'
import apple from '../images/podcast/apple.png'
import google from '../images/podcast/google.png'
import overcast from '../images/podcast/overcast.png'
import breaker from '../images/podcast/breaker.png'
import radiopublic from '../images/podcast/radiopublic.png'

const CustomSection = styled(Section)`
    max-width: 90%;
    margin: 0 auto;
	flex-direction: column;
	padding-bottom: 8rem;
`;

const Title = styled.h2`
    color: #000;
    text-align: center;
	font-size: 32px;
	line-height: 1.4;
	margin-bottom: 2rem;
`;

const Lead = styled.div`
    font-style: italic;
	text-align: center;
    font-size: 20px;
    margin-bottom: 3rem;
`;

const Body = styled.div`
    font-size: 18px;
	max-width: 700px;
	margin: 0 auto 3rem;
	line-height: 1.5;
`;

const ImageWrapper = styled.div`
    max-width: 90%;
    width: 250px;
	margin: 5rem auto 2rem;
`;

const DualImage = styled.div`
    display: flex;
    margin: 0 auto;
    width: 300px;

    @media (min-width: 650px) {
        width: 600px;
    }
`

const ImageWrapper2 = styled(ImageWrapper)`
    width: 300px;
    margin-bottom: 3rem;
`

const ImageWrapper3 = styled(ImageWrapper)`
    width: 300px;
    margin-bottom: 2rem;
`

const ImageWrapper4 = styled(ImageWrapper)`
    width: 250px;
    margin-bottom: 3rem;
    cursor: pointer;
`

const After = styled.div`
    margin-top: 3rem;
    margin-bottom: 1rem;
	text-align: center;
`;

const PodcastLinks = styled.ul`
	display: flex;
	justify-content: center;
	flex-wrap: wrap;
	line-height: 2;
	
	li {
	    margin: 0 0.5rem;
	}
	
	img {
	    width: 32px;
	    height: 32px;
	}
`;

const Works = () => {
	return (
		<CustomSection>
            <Fade duration={500} up cascade>
                <DualImage>
                <ImageWrapper>
                    <CertifiedEmotionCode />
                </ImageWrapper>
                <ImageWrapper>
                    <CertifiedBodyCode />
                </ImageWrapper>
                </DualImage>
                <Title>Certified Emotion Code Practitioner,<br />Certified Body Code Practitioner</Title>
                <Lead>Owner of <strong>Compass Healing Center</strong>, since 2015</Lead>
                <Body>Dr. Bradley Nelson and the Discover Healing team found a modality called the Emotion and Body Code. This modality currently has 1,300 Body Code practitioners and over 4000 Emotion Code practitioners worldwide. His recently revised book The Emotion Code by Dr. Bradley Nelson, which was forwarded by Tony Robbins, has become the most cutting-edge modality in the world. Emanuel is certified in both the Emotion and Body Code and has been working with clients on a global scale for six years. He meets with over 80 clients a week at Compass Healing. His practice is the highest-rated practice with over 700 5-star reviews. He is currently employing other practitioners to work at his practice as he spends more time building the Inside Out Institute with his business partner Todd Cahill.
                </Body>
            </Fade>
            {/*<Fade duration={500} up cascade>*/}
            {/*    <ImageWrapper2>*/}
            {/*        <InsideOut />*/}
            {/*    </ImageWrapper2>*/}
            {/*    <Title>Co-Founder and Chief Healing Officer</Title>*/}
            {/*    <Lead>Inside Out Institute, 2020</Lead>*/}
            {/*    <Body>Todd Cahill, Amazon best seller for You vs You and millionaire serial entrepreneur, was on a mission to help transform his clients in his transformational coaching program. During the Covid-19 pandemic, Emanuel volunteered the idea to help his clients by first doing a Body Code session with Todd himself. He felt immediate results on an emotional and physical level. Since that session, they brainstormed on how to create a program where transformational coaches and Emotion/Body Code practitioners can align their talents to help other leaders. Emanuel currently adds his input on how to incorporate the Body Code with the You Vs. You program. He develops video content, attends mastermind calls with all the leaders, and speaks all over the world about this modality and the power behind Inside Out Institute. He believes it will be the most cutting-edge institute that combines the power of the conscious and subconscious mind to create a true transformational leadership program.</Body>*/}
            {/*</Fade>*/}
            <Fade duration={500} up cascade>
                <ImageWrapper3>
                    <Healer />
                </ImageWrapper3>
                <Title>Healers Success Guide</Title>
                <Lead>Founder, 2017</Lead>
                <Body>Emanuel designed an online training program to help Emotion and Body Code practitioners to make a life sustaining income. He saw the need to aid practitioners when he discovered one of his favorite Body Code practitioners was struggling financially. He thoroughly believes that talent doesn’t pay the bills unless high quality marketing methods are implemented. He designed a program that took 12 months of studying clients to produce training modules where he would provide healing sessions and a training program to help his learners excel in their practice. Many of his students are now producing a life sustaining income due to the instruction given in his program. He plans on adding pieces of this program to the Inside Out Institute to add a higher proficiency for leaders as part of their graduation.</Body>
            </Fade>
            <Fade duration={500} up cascade>
                <ImageWrapper4>
                    <a href="https://anchor.fm/HealingTheHealer" rel="noreferrer" target="_blank">
                        <Podcast />
                    </a>
                </ImageWrapper4>
                <Title>Healing the Healer Podcast</Title>
                <Lead>Podcast Host, 2020</Lead>
                <Body>Emanuel and Jessica decided to come together to make a Podcast where practitioners can have a resource to learn more about the Emotion and Body Code via their cumulative six years of practice. He provides different tools, questions, and ways to approach clients so listeners can obtain the same amount of success that he has achieved. As a Christian, he provides a perspective that is warranted in the Energy Healing space as he shares that energy healing is just a tool we can use and not a religion or mystic way to provide value. It is based on science, quantum physics, and the positive intentions of a practitioner who wants to remove imbalances from the human system.</Body>
                <After>The podcast is available on the following platforms:</After>

                <PodcastLinks>
                    <li><a href="https://open.spotify.com/show/1darqYdhrezXFW1ugGCdwD" rel="noreferrer" target="_blank"><img src={spotify} /></a></li>
                    <li><a href="https://podcasts.apple.com/us/podcast/healing-the-healer-podcast/id1507981354?uo=4" rel="noreferrer" target="_blank"><img src={apple} /></a></li>
                    <li><a href="https://www.google.com/podcasts?feed=aHR0cHM6Ly9hbmNob3IuZm0vcy8xYjIwNWFiMC9wb2RjYXN0L3Jzcw==" rel="noreferrer" target="_blank"><img src={google} /></a></li>
                    <li><a href="https://overcast.fm/itunes1507981354/healing-the-healer-podcast" rel="noreferrer" target="_blank"><img src={overcast} /></a></li>
                    <li><a href="https://www.breaker.audio/healing-the-healer-podcast" rel="noreferrer" target="_blank"><img src={breaker} /></a></li>
                    <li><a href="https://radiopublic.com/healing-the-healer-podcast-GKBj5z" rel="noreferrer" target="_blank"><img src={radiopublic} /></a></li>
                </PodcastLinks>
            </Fade>
        </CustomSection>
	)
}

export default Works;
